import { render, staticRenderFns } from "./SithMesNcrTaskNccList.vue?vue&type=template&id=60fa94ec&"
import script from "./SithMesNcrTaskNccList.vue?vue&type=script&lang=js&"
export * from "./SithMesNcrTaskNccList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports